"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpotDataUtils = void 0;
const data_1 = require("../../../data");
class SpotDataUtils {
    static createBalancesFromAccountInformation(accountInfo) {
        const userAssets = SpotDataUtils.getNonNullAssetsFromAccountInformation(accountInfo);
        return new data_1.SpotUserBalance({
            initialAssets: SpotDataUtils.assetRawToBalanceInitialAsset(userAssets),
            marketData: {
                marketAssets: new Map()
            }
        });
    }
    static getNonNullAssetsFromAccountInformation(accountInfo) {
        return accountInfo.balances.filter(asset => {
            return Number(asset.free) !== 0;
        });
    }
    static assetRawToBalanceInitialAsset(assets) {
        return assets.map(asset => {
            return {
                assetId: asset.asset,
                assetBalance: Number(asset.free)
            };
        });
    }
}
exports.SpotDataUtils = SpotDataUtils;
